import ForumIcon from '@mui/icons-material/Forum';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import QuizIcon from '@mui/icons-material/Quiz';
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import React from 'react';
import { Link } from '~/components/Link';
import type { Item } from './types';

interface SupportMenuProps {
  isGuest: boolean;
}

export const supportMenuItems: Item[] = [
  {
    href: '/support#data',
    title: 'Data Documentation',
    icon: () => <HelpOutlineIcon />,
  },
  {
    href: '/support#faq',
    title: 'Frequently Asked Questions',
    icon: () => <QuizIcon />,
  },
  {
    href: '/support#contact',
    title: 'Contact Us',
    icon: () => <ForumIcon />,
  },
];

export const SupportMenu = ({ isGuest }: SupportMenuProps) => {
  const [menuElement, setMenuElement] = React.useState<null | HTMLElement>(
    null
  );

  const onMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuElement(event.currentTarget);
  };

  const onMenuClose = () => {
    setMenuElement(null);
  };
  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Support and Documentation">
        <IconButton
          onClick={onMenuOpen}
          sx={{ my: 2 }}
          size={isGuest ? 'medium' : 'large'}>
          <HelpOutlineIcon style={{ color: 'white' }} fontSize="large" />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        anchorEl={menuElement}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menuElement)}
        onClose={onMenuClose}>
        {supportMenuItems.map((item, index) => {
          return (
            <MenuItem
              onClick={onMenuClose}
              href={item.href}
              key={item.href}
              component={Link}
              LinkComponent={(props) => (
                <Link
                  {...props}
                  onClick={onMenuClose}
                  href={item.href}
                  underline="none"
                  key={index}
                />
              )}>
              <ListItemIcon>
                <item.icon />
              </ListItemIcon>
              <ListItemText>{item.title}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};
